import { observer } from 'mobx-react';
import LinearProgress from '@mui/material/LinearProgress';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { ProgressBarProps } from '../types/global';

const ProgressBar = observer(({ actual, max, message }: ProgressBarProps) => {
  const hasValidProgress = max > 0; // allow progress bar from the moment max is set
  const showMessageOnly = !hasValidProgress && !!message;
  const progress = hasValidProgress ? (actual / max) * 100 : 0;

  if (progress === 100) {
    return null;
  }

  return (
    <Box sx={{ width: '100%' }}>
      {hasValidProgress && (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant='determinate' value={progress} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography
              variant='body2'
              sx={{ color: 'text.secondary' }}
            >{`${Math.round(progress)}%`}</Typography>
          </Box>
        </Box>
      )}
      {(hasValidProgress || showMessageOnly) && message && (
        <Box mt={1}>
          <Typography variant='body2' sx={{ color: 'text.secondary' }}>
            {message}
          </Typography>
        </Box>
      )}
    </Box>
  );
});

export default ProgressBar;
